var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('div',[_c('GeneralInformation',{attrs:{"general-info":_vm.generalInfo}})],1),(_vm.surveyIdComp !== null)?_c('div',{staticClass:"mt-4"},[_c('AddSurvey',{attrs:{"isDisabled":true,"surveyIdComp":_vm.surveyIdComp}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }